import { ArrowRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

interface IProps {
  headingHide?: boolean;
  text: string;
  imagesArray?: string[];
  toggleGalleryModal?: () => void;
}

const Team: React.FC<IProps> = ({
  headingHide = false,
  text,
  imagesArray,
  toggleGalleryModal,
}) => {
  return (
    <div>
      <div
        className={`flex justify-center items-center ${headingHide ? "hidden" : ""}`}
      >
        <div className="flex flex-col text-2xl font-normal sm:text-2xl text-white md:text-3xl xl:text-4xl">
          <h3>Take a peep at what goes on at Dream Weavers!</h3>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 w-full justify-center py-10">
        <div className="grid col-span-2 gap-5">
          <div>
            <img
              src={imagesArray?.[0] || "/careers/team/team-01.png"}
              alt=""
              className="w-full h-full"
            />
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div>
              <img
                src={imagesArray?.[1] || "/careers/team/team-02.png"}
                alt=""
              />
            </div>
            <div>
              <img
                src={imagesArray?.[2] || "/careers/team/team-03.png"}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="grid gap-5 col-span-1">
          <div>
            <img
              src={imagesArray?.[3] || "/careers/team/team-04.png"}
              alt=""
              className="w-full h-full"
            />
          </div>
          <div>
            <img
              src={imagesArray?.[4] || "/careers/team/team-05.png"}
              alt=""
              className="w-full h-full"
            />
          </div>
        </div>
        <div className="flex flex-col col-span-1 h-full gap-5">
          <div className="h-fit">
            <img
              src={imagesArray?.[5] || "/careers/team/team-06.png"}
              alt=""
              className="h-fit"
            />
          </div>
          {/* todo: add to link here */}
          {text === "Check our Team of Professionals" ? (
            <Link
              to="/company"
              className="p-5 flex flex-col h-full text-white justify-end bg-[#FFFFFF1A]"
            >
              <p className="text-base lg:text-lg font-light xl:text-2xl">
                {text}
              </p>
              <div>
                <ArrowRight className="w-5" />
              </div>
            </Link>
          ) : (
            <div
              onClick={toggleGalleryModal}
              className="p-5 cursor-pointer flex flex-col justify-center h-full text-white items-center bg-[#FFFFFF1A]"
            >
              <p className="text-base lg:text-lg font-light xl:text-2xl">
                {text}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Team;
